import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { modalConfig, modalContent } from "./thankyouModalData";

const ThankYouDialog = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return;

    if (onClose) {
      onClose(event, reason);
    }

    setTimeout(() => {
      navigate(modalConfig.redirectPath);
    }, modalConfig.redirectDelay);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            maxWidth: modalConfig.maxWidth,
            width: "96vw",
            m: 0,
            p: 0,
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          p: 0,
          pt: 2.5,
          pb: 0,
          borderBottom: "none",
        }}
      >
        <CheckCircleIcon
          fontSize="large"
          sx={{ color: "#24c27c", fontSize: 40, mb: 0.5 }}
        />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            letterSpacing: 0.5,
            fontSize: 18,
            mt: 0.3,
          }}
        >
          {modalContent.title}
        </Typography>
      </DialogTitle>

      <DialogContent
        dividers={false}
        sx={{
          textAlign: "center",
          px: 2,
          pt: 1.5,
          pb: 0.5,
          bgcolor: "#fafdff",
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              color: "#59729b",
              fontSize: 14,
              mb: 0,
              mt: 0.5,
              lineHeight: 1.6,
            }}
          >
            {modalContent.message}
            <br />
            {modalContent.submessage}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 2,
          pt: 1.5,
          px: 2,
        }}
      >
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleClose}
          sx={{
            minWidth: 80,
            fontWeight: 600,
            fontSize: 14,
            borderRadius: 2,
            py: 0.7,
            letterSpacing: 0.3,
            width: "auto",
            mx: "auto",
          }}
        >
          {modalContent.closeButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThankYouDialog;
